import React from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { ScrollText, CalendarCheck2, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AnnualReportsPage() {
  return (
    <main>
      <PageHeader eyebrow="Annual Reports" title="Open books, from day one." lead="Citizen Awareness Foundation was incorporated in 2026 as a Section 8 company. Our first audited annual report will cover FY 2026-27." />
      <section className="container-wide py-12 max-w-3xl">
        <div className="rounded-2xl border border-dashed border-[hsl(var(--border))] p-10 text-center bg-card" data-testid="annual-reports-empty">
          <ScrollText className="h-10 w-10 mx-auto text-[hsl(var(--green))]" />
          <h2 className="heading-3 mt-4">First report: FY 2026-27</h2>
          <p className="text-sm text-[hsl(var(--muted-ink))] mt-3 max-w-md mx-auto">We are in our founding year. The first statutory audit and annual report will be published here at the end of FY 2026-27 — with program impact, audited finances and independently sampled beneficiary data.</p>
          <div className="mt-6 grid sm:grid-cols-2 gap-3 text-left text-sm max-w-lg mx-auto">
            <div className="rounded-lg border border-[hsl(var(--border))] p-4 flex items-start gap-3">
              <CalendarCheck2 className="h-4 w-4 mt-0.5 text-[hsl(var(--orange))]" />
              <span className="text-[hsl(var(--muted-ink))]">Quarterly impact briefs will be shared on our blog until the first audit.</span>
            </div>
            <div className="rounded-lg border border-[hsl(var(--border))] p-4 flex items-start gap-3">
              <ShieldCheck className="h-4 w-4 mt-0.5 text-[hsl(var(--green))]" />
              <span className="text-[hsl(var(--muted-ink))]">Our live donation ledger is already public on the Transparency page.</span>
            </div>
          </div>
          <Link to="/transparency"><Button className="mt-7 rounded-full bg-[hsl(var(--orange))] hover:bg-[hsl(var(--orange-2))] text-black font-semibold" data-testid="annual-reports-transparency-cta">View live Transparency Dashboard</Button></Link>
        </div>
      </section>
    </main>
  );
}
